import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { permanentRedirect } from "@/lib/legacyRedirects";

/** Gammal URL – permanent omdirigering (301). */
export const Route = createFileRoute("/historiska-elpriser/$rest")({
  head: () => seoHead("/historiska-elpriser/$rest"),
  beforeLoad: () => permanentRedirect("/elpriser/historik"),
});
